import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { PatientEngagementService } from '../../services/patient-engagement.service';
import { TransactionItems } from '../../models/transactions.models';
import { messages } from '../../../../constants/app.messages';
import { TransactionService } from '../../services/transaction.service';
import { forkJoin } from 'rxjs';
import { StateService } from '../../services/history.state.service';
import { Router } from '@angular/router';
import { constant } from '../../../../constants/app.constants';
import { SignatureSource, SignatureType } from '../../../SecurePatientCommunication/models/chat.enum';
import moment from 'moment';

@Component({
  selector: 'app-review-order',
  templateUrl: './review-order.component.html',
  styleUrl: './review-order.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class ReviewOrderComponent implements OnInit  {
  selectedTransDetails: any;
  @Output() GoToTransList = new EventEmitter();
  transDrugImages: any = [];
  elinkParams: any = {};
  eLinkData: any;
  transactionsResp: any = {};
  transactionItems: any = [];
  isGuestUser:boolean= false;
  captureSign: boolean = false;
  deleteSignId: any;
  signatureList: any = [];
  copayValue: any;
  todayDate: any;
  nonZeroCopay: boolean = false;
  localToUtcFormat: string | undefined;
  openProcessPaymentModal: boolean = false;
  constructor(
      private _peServie: PatientEngagementService,
      private _transService: TransactionService,
      private stateService: StateService,
      private _router: Router) {}

  ngOnInit() {
    this.isGuestUser = JSON.parse(localStorage.getItem('IsGuestUser') as string);
    const storedDetails = localStorage.getItem("selectedTransDetails");
    if (storedDetails && storedDetails !== 'undefined') {
        this.selectedTransDetails = JSON.parse(storedDetails);
    } else {
      this._transService.selectedTransaction$.subscribe(selectedTrans => {
        this.selectedTransDetails = selectedTrans; 
      });
    }
    this.getPendingTranscationDrugImages();
    this.todayDate = moment().local().format("MM/DD/YYYY hh:mm:ss A");
     this.localToUtcFormat = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    
  }
  
  getPendingTranscationDrugImages() {
    this.elinkParams = JSON.parse(localStorage.getItem('paramsData') as string);
    if (this.selectedTransDetails?.salesDetailsList?.length) {
      const ndcList: any = [];
      this.selectedTransDetails?.salesDetailsList?.filter((item: any) => {
        if (item['rxDetails']?.ndc)
          ndcList.push(item['rxDetails'].ndc);
      });
      this._peServie.getDrugImagesBasedonNDC({
        "NpiNo": this.elinkParams?.npi,
        "NdcList": ndcList
      }).subscribe((resp: any) => {
        if (resp) {
          this.transDrugImages = resp;
        }
      });
    }
  }  
  goToTranscationList() {
    this.GoToTransList.emit(true);
    this.stateService.setActiveSection('pendingPayments');
    this._router.navigate(['/PendingPayments']);
  }

  getImageUrl(selectedItemNDC: any) {
    const item = this.transDrugImages?.imageDetails?.find((item: any) => { return (selectedItemNDC === item['ndc']) });
    return item ? item.imageUrl : this.transDrugImages.emptyUrl;
  }
  async setUpTrans() {
    try{ 
        if (this.selectedTransDetails?.salesDetailsList?.length) {
          this.selectedTransDetails?.salesDetailsList.map((item: any) => {
            if (item && item?.rxDetails) {
              const transItem = new TransactionItems();
              transItem.RxNo = item?.rxDetails?.rxno;
              transItem.RefillNo = (item?.rxDetails?.nrefill);
              transItem.PartialFillNo = (item?.rxDetails?.partialFillNo);
              transItem.DrugName = item?.rxDetails?.detdrgname
              transItem.Amount = item?.rxDetails?.copay
              transItem.Quantity = item?.rxDetails?.quant
              this.transactionItems.push(transItem);
            }
          });
          this.elinkParams = JSON.parse(localStorage.getItem('paramsData') as string);
          this.eLinkData = JSON.parse(localStorage.getItem('eLinkData') as string);
          localStorage.setItem("ActiveTransId",this.selectedTransDetails?.transID)
          const setupSaleTransactionsObj: any = {
            NpiNo: this.elinkParams?.npi, PatientNo: JSON.stringify(this.eLinkData?.EntityId), Amount: this.selectedTransDetails?.amount, TransId: this.selectedTransDetails?.transID,
            TransactionItems: this.transactionItems
          };
          localStorage.setItem("setupSaleTransactionsObj", JSON.stringify(setupSaleTransactionsObj));
          setupSaleTransactionsObj.allowTokenSaving = this.selectedTransDetails.allowTokenSaving;
          setupSaleTransactionsObj.CustomCss = messages.customCssChanges;
          setupSaleTransactionsObj.TransactionSetupMethod ="2"; 
          if (setupSaleTransactionsObj) {
            //console.log(setupSaleTransactionsObj,'setupSaleTransactionsObj');
              await this._peServie.setUpTrans(setupSaleTransactionsObj).subscribe((resp: any) => {
                localStorage.setItem("ResponseObject", JSON.stringify(resp));
                if (resp && resp?.paymentTransactionURL && resp?.transactionSetupID) {
                  this.transactionsResp = resp;
                  localStorage.removeItem("setupSaleTransactionsObj");
                  window.location.href =  resp?.paymentTransactionURL + resp?.transactionSetupID ,'popup','width=1000,height=1000';
                  localStorage.setItem("signatureId",this.deleteSignId)
                } else {
                  this.stateService.setActiveSection('pendingPayments');
                  this._router.navigate(['/PendingPayments'], {
                    queryParams: { message: constant.trans_fialed_MSG }
                  });
                }
            },
            (error: any) => {
              // Handle transaction failure case
              this.stateService.setActiveSection('pendingPayments');
              this._router.navigate(["/PendingPayments"], {
                queryParams: { message: 'Transaction failed, please contact the administrator.' }
              });
              let payload = {
                insSigTransId: this.deleteSignId,
                pharmacyNPI: this.elinkParams?.npi,
              }
              this._peServie.deleteSignature(payload).subscribe((res)=>{
                if (res) {
                  console.log("Signature is Deleted")
                }
              })
            });
        }
        }
      } catch (error) {
          console.error("Error:", error);
      }
  }

  openSignaturePopup() {
    this.captureSign = true;
    const styleForPayNow = document.querySelector('.order-place') as HTMLElement;
    if (styleForPayNow) {
      styleForPayNow.style.zIndex = 'unset';
    }
  }
  
  signatureCheck(event: any) {
    this.captureSign = false;
    if (event) {
       this.copayValue = this.selectedTransDetails?.amount
       const payloadForsetupSaleSig = {
       signatureImageBase64: event.replace(/^data:image\/(png|jpeg);base64,/, ''),
      signatureSource: SignatureSource.MyPrimeRx,
      signatureType: SignatureType.Payment,
      SignatureDtTm: this.localToUtcFormat
    };
      this.signatureList = [payloadForsetupSaleSig];
          const payload = {
          transID: this.selectedTransDetails?.transID,
          npiNo: this.elinkParams?.npi,
          Signatures: this.signatureList
          }
          this._peServie.addSignatureOnly(payload).subscribe(resp=>{
           localStorage.setItem("copayValue", this.selectedTransDetails?.amount);
          this._router.navigate(['/payment-confirm']);
            });
    }
  }
  checkCopayValue(){
   const zeroCopay = !this.selectedTransDetails?.amount;
    const payload = {
    selectedTransDetails: this.selectedTransDetails,
    zeroCopay,
    meta: {
      npi: this.elinkParams?.npi,
      patientId: JSON.parse(localStorage.getItem('eLinkData') || '{}')?.EntityId
    }
  };
    this._router.navigate(['/process-payment'], { state: { payload } });
  }
}
